import { render, staticRenderFns } from "./CourseTile.vue?vue&type=template&id=b6114e90&"
import script from "./CourseTile.vue?vue&type=script&lang=js&"
export * from "./CourseTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports